import { Node } from '@tiptap/core'
import type { GeneralOptions } from '@/notebook/type'
import ActionButton from './components/AIButton.vue'

export type MenuItem = {
  label: string
  prompt?: string
  children?: MenuItem[]
}
export type AIOptions = {
  completions: (prompt: string, text: string, signal?: AbortSignal) => Promise<any>
  /**
   * AI Shortcuts Menu
   */
  shortcuts: MenuItem[]
} & GeneralOptions<AIOptions>

export const AI = Node.create<AIOptions>({
  name: 'AI',
  group: 'block',
  addOptions() {
    return {
      ...this.parent?.(),
      toolbar: false,
      button: ({ editor, t }) => ({
        component: ActionButton,
        componentProps: {
          icon: 'Sparkles',
          tooltip: t('editor.AI.ask'),
        },
      }),
    }
  },
})
